import React from "react";
import styled from "styled-components";
import { IoClose } from "react-icons/io5";
const MyModal = ({ modalTitle, modalSubtitle, isOpen, onClose, children, className }) => {
  if (!isOpen) return null;
  return (
    <StyledModal onClick={onClose}>
      <div className={`modal-contents ${isOpen ? "open" : ""} ${className}`} onClick={(e) => e.stopPropagation()}>
        <div className="modal-head d-flex align-items-center justify-content-between">
          <div className="modal-head-content">
            <div className="d-flex align-items-center justify-content-between">
              {modalTitle && <h5 className="text-black mb-0">{modalTitle}</h5>}{" "}
              <button className="modal-close " onClick={onClose}>
                <IoClose className="rounded-circle " color="#000" size={20} />
              </button>
            </div>
            {modalSubtitle && <p className="text-muted mt-1">{modalSubtitle}</p>}
          </div>
        </div>
        {children}
      </div>
    </StyledModal>
  );
};

export default MyModal;

const StyledModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  transition: all 0.3s ease-in-out;

  .modal-contents {
    background: white;
    border-radius: 8px;
    padding: 20px;
    width: 90%;
    max-width: 500px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    transform: translateY(0);
    transition: all 0.3s ease-in-out;
  }

  /* Mobile Animation */
  @media (max-width: 768px) {
    .modal-contents {
      position: absolute;
      bottom: 0;
      border-radius: 8px 8px 0 0;
      width: 100%;
      max-width: 100%;
      transform: translateY(100%);
    }

    .modal-contents.open {
      transform: translateY(0);
    }
  }

  .modal-close {
    display: block;
    background: #dff3ff;
    color: white;
    border: none;
    height: 40px;
    width: 40px;
    border-radius: 100%;
    cursor: pointer;
  }
`;
